import React from "react";

import { EllipsisOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";

const MoreButton = ({ items }: { items: MenuProps["items"] }) => {
  return (
    <Dropdown menu={{ items }} placement="bottomLeft">
      <Button type={"default"} icon={<EllipsisOutlined />} />
    </Dropdown>
  );
};

export default MoreButton;
